import Vue from 'vue'

export const replaceStore = Vue.observable({
  isNavOpen: false,
  isNext: false,
})

export const replaceMutations = {
  setIsNavOpen(yesno) {
    replaceStore.isNavOpen = yesno
  },
  toggleNav() {
    replaceStore.isNavOpen = !replaceStore.isNavOpen
  },
  resetNext() {
    replaceStore.isNext = false
  },
  toggleNext() {
    replaceStore.isNext = true
  },
}
